<div class="page-container" fxLayout="column" fxLayoutAlign="center center">
  <div class="timer-container" fxFlex=5>
    <tech-core-quiz-progress-bar (progressComplete)="handleTimeOut()"></tech-core-quiz-progress-bar>
  </div>

  <form [formGroup]="questionForm"></form>

  <div class="questions-container" fxFlex="85">
    <h2>{{ questions[currentQuestionIndex].question }}</h2>
    <div class="answer-container" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
      <eon-ui-button *ngFor="let answer of questions[currentQuestionIndex]?.answers"
                     fullWidth rank="secondary" [text]="answer"
                     scheme="red"
                     [disabled]="isAnswered"
                     (click)="selectAnswer(answer)">
      </eon-ui-button>
    </div>
  </div>

  <p *ngIf="feedbackMessage" class="feedback-message" [innerHTML]="feedbackMessage"></p>

  <div class="footer-controls" fxLayoutAlign="space-between" fxFlex=10>
    <p>{{ currentQuestionIndex + 1 }}/{{ questions.length }}</p>
    <eon-ui-button text="Next" (click)="nextQuestion()" [disabled]="!isAnswered"></eon-ui-button>
  </div>
</div>
